import { useState, useEffect } from "react";
import { Grid, TextField, Autocomplete, IconButton, Box } from "@mui/material";
import { useCategoryStore } from "../../../hooks/useCategoryStore";
import { useSubcategoryStore } from "../../../hooks/useSubcategoryStore";
import { useSpecificSubcategoryStore } from "../../../hooks/useSpecificSubcategoryStore";
import SearchIcon from '@mui/icons-material/Search';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useProductAttributeStore } from "../../../hooks/useProductAttributeStore";
import { useProductUsageAttributeStore } from "../../../hooks/useProductUsageAttributeStore";
import '../../../assets/styles/facturacionv3-app.css';

export const CustomSearchProducts: React.FC<any> = (props): JSX.Element | any => {
    const { setProducts, getProductsApi } = props;
    const { getCategoriesWithProducts } = useCategoryStore();
    const { getSubcategoriesWithProducts } = useSubcategoryStore();
    const { getSpecificsubcategoriesBySubCategory } = useSpecificSubcategoryStore();
    const { getproductAttributeByCompany } = useProductAttributeStore();
    const { getProductUsageAttributeByCompany } = useProductUsageAttributeStore();

    const [value, setValue] = useState('1');
    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [categories, setcategories] = useState<any>([]);
    const [categoryselected, setcategoryselected] = useState<any>('');
    const [subcategories, setsubcategories] = useState<any>([]);
    const [subcategoryselected, setsubcategoryselected] = useState<any>('');
    const [specificsubcategories, setspecificsubcategories] = useState<any>([]);
    const [specificsubcategoryselected, setspecificsubcategoryselected] = useState<any>('');

    const [attributes, setattributes] = useState<any>([]);
    const [attributeselected, setattributeselected] = useState<any>([]);
    const [specificattributes, setspecificattributes] = useState<any>([]);
    const [specificattributeselected, setspecificattributeselected] = useState<any>('');

    const [uses, setuses] = useState<any>([]);
    const [useselected, setuseselected] = useState<any>([]);
    const [specificuses, setspecificuses] = useState<any>([]);
    const [specificuseselected, setspecificuseselected] = useState<any>('');

    useEffect(() => {
        getCategoriesApi();
        getSubcategoriesApi();
    }, []);

    useEffect(() => {
        if (value == '2') getproductAttributeApi();
    }, [value]);

    useEffect(() => {
        if (value == '3') getProductUseApi();
    }, [value]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getCategoriesApi = async (search = '') => {
        try {
            setLoadingdata(true);
            const response = await getCategoriesWithProducts(search);
            if (!response) {
                setcategories([]); setLoadingdata(false); return false;
            } else {
                setcategories(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getSubcategoriesApi = async (search = '') => {
        try {
            setLoadingdata(true);
            const response = await getSubcategoriesWithProducts(search);
            if (!response) {
                setsubcategories([]); setLoadingdata(false); return false;
            } else {
                setsubcategories(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getSpecificsubcategoriesBySubCategoryApi = async (search = '', idsubcategory) => {
        try {
           
            const response = await getSpecificsubcategoriesBySubCategory(search, idsubcategory);
            if (!response) {
                setspecificsubcategories([]); setLoadingdata(false); return false;
            } else {
                setspecificsubcategories(response || []); 
            }
        } catch (error) {
            
        }
    }

    const getproductAttributeApi = async (search = '') => {
        try {
            //
            const response = await getproductAttributeByCompany(search);
            if (!response) {
                setattributes([]); setLoadingdata(false); return false;
            } else {
                setattributes(response || []); setLoadingdata(false);
            }
        } catch (error) {
            // 
        }
    }

    const getProductUseApi = async (search = '') => {
        try {
            //
            const response = await getProductUsageAttributeByCompany(search);
            if (!response) {
                setuses([]); 
                // 
                 return false;
            } else {
                setuses(response || []); 
                // 
            }
        } catch (error) {
            // 
        }
    }

    const getFilters = () => {
        getProductsApi && getProductsApi('', categoryselected?.id, subcategoryselected?.id, specificsubcategoryselected?.id);
    }

    const cancelFilters = () => {
        setcategoryselected('');
        setsubcategoryselected('');
        setspecificsubcategoryselected('');
        getProductsApi && getProductsApi();
    }

    return (
        <Grid container sx={{ padding: '0px 20px 10px 20px' }}>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="basic tabs example">
                    </TabList>
                </Box>

                <TabPanel value="1" sx={{ width: '100%', padding: '15px 0px 20px 0px' }}>
                    <Grid item container xs={12} spacing={2} alignItems='center'>
                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                id="idofficetype"
                                size="small"
                                value={!!categoryselected ? categoryselected : null}
                                options={categories || []}
                                loading={loadingdata}
                                getOptionLabel={(option) => option?.name || ''}
                                isOptionEqualToValue={(option, value) => option.name === value?.name}
                                renderInput={(params) =>
                                    <TextField {...params} label="" size="small" placeholder="categorias" />
                                }
                                onChange={(e, newValue: any) => {
                                    setcategoryselected(newValue);
                                    setsubcategoryselected('');
                                    setspecificsubcategoryselected('');
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                id="idofficetype"
                                size="small"
                                value={!!subcategoryselected ? subcategoryselected : null}
                                options={subcategories || []}
                                loading={loadingdata}
                                getOptionLabel={(option) => option?.name || ''}
                                isOptionEqualToValue={(option, value) => option.name === value?.name}
                                renderInput={(params) =>
                                    <TextField {...params} label="" size="small" placeholder="subcategorias" />
                                }
                                onChange={(e, newValue: any) => {
                                    setsubcategoryselected(newValue);
                                    setspecificsubcategoryselected('');
                                }}
                            />
                        </Grid>
                        {/* <Grid item xs={12} md={3}>
                            <Autocomplete
                                id="idofficetype"
                                size="small"
                                value={!!specificsubcategoryselected ? specificsubcategoryselected : null}
                                options={specificsubcategories || []}
                                loading={loadingdata}
                                getOptionLabel={(option) => option?.name || ''}
                                isOptionEqualToValue={(option, value) => option.name === value?.name}
                                renderInput={(params) =>
                                    <TextField {...params} label="" size="small" placeholder="subcategorias específicas" />
                                }
                                onChange={(e, newValue: any) => {
                                    setspecificsubcategoryselected(newValue);
                                }}
                            />
                        </Grid> */}
                        <Grid item xs={12} md={2} display='flex' justifyContent='center' alignItems='center' sx={{ padding: '0px' }}>
                            <button onClick={getFilters} className="btn-search">
                                <IconButton aria-label="delete" size="small">
                                    <SearchIcon fontSize="inherit" sx={{ color: '#FFFFFF' }} />
                                </IconButton>
                            </button>
                            <button onClick={cancelFilters} style={{ cursor: 'pointer' }}>
                                cancelar filtro
                            </button>
                        </Grid>
                    </Grid>
                </TabPanel>
            </TabContext>
        </Grid>
    );
}
